const spacing = {
  nudge: 16,
};

export default spacing;
